import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

class App extends Component {
	render() {
		return (
			<div className="App">
				<header className="App-header">
					<img src={logo} className="App-logo" alt="logo" />
					<h1 className="App-title">Bem vindo ao React</h1>
				</header>
				{this.props.children}
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx